import React from 'react';
import _ from 'lodash';

import { withTranslation } from 'language/i18n';
import PropTypes from 'prop-types';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import LeftMenu from '../components/selling/LeftMenu';
import ContactUsForm from '../components/selling/ContactUsForm';
import Feature from '../components/selling/Feature';
import ContactUs from '../components/ContactUs';
import SellYourMachineIn30Days from '../components/SellYourMachineIn30Days';

const SimpleSalesProcess = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('selling'),
      url: '/content/selling/auction-process',
    },
    {
      label: 'Kolay Satış Sistemi',
      url: '/content/selling/simple-sales-process',
    },
  ];

  const items = [
    {
      title: 'DOĞRU KANAL',
      subtitle: '45 Yıllık Tecrübe',
      descriptions: [
        'Her ilden binlerce kullanıcıya sahip bir kanal',
        'En iyi fiyatla satış yapmak için adil rekabet ortamı',
        'Profesyonelce yönetilen satış süreci',
      ],
      svgIcon: '/image/icons.svg#ic-channel-yellow',
    },
    {
      title: 'DOĞRU ZAMAN',
      subtitle: '7/24 Satış İmkanı',
      descriptions: [
        '30 günde sorunsuz satış',
        'Tüm teklifleri anlık görebilme imkanı',
        'Piyasa koşullarına göre doğru zamanda satış imkanı',
      ],
      svgIcon: '/image/icons.svg#ic-time-yellow',
    },
    {
      title: 'DOĞRU MÜŞTERİ',
      subtitle: 'Her İlden Binlerce Ziyaretçi',
      descriptions: [
        'Online açık artırma ile ülke geneli müşteri bulma imkanı',
        'Teminat Bedeli sayesinde güvenilir alıcılara ulaşma imkanı',
        'Zorluklarla uğraşmadan doğru alıcılara ulaşma imkanı',
      ],
      svgIcon: '/image/icons.svg#ic-users-yellow',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <LeftMenu currentPage="simple-sales-process" />
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Kolay Satış Sistemi</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  45 yıllık tecrübemizle tüm süreci yönetelim. Makinanıza detaylı ekspertiz yapalım, alıcı bulmanın tüm zorluklarıyla biz uğraşalım, güvenilir şekilde ödemeyi size teslim edelim.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15 col-lg mb-3 mb-lg-0">
                <div className="im-box im-box--white im-box--shadow im-box--height-100p d-flex align-items-center">
                  <ul className="im-step-bar3">
                    <li className="im-step-bar3__item">
                      <div className="im-step-bar3__item__indicator">
                        <span className="fs-70 fw-900 text-yellow2">1</span>
                      </div>
                      <div className="im-step-bar3__item__title">DETAYLI EKSPERTİZ</div>
                      <div className="im-step-bar3__item__description">
                        Ekspertize tabi tutulmuş makinanızı görsel malzemelerle destekleyelim. Uzman ekibimiz makinanızın detaylı fotoğraf ve videolarını çekerek satış sürecinin hızlanmasına yardımcı olsun.
                      </div>
                    </li>
                    <li className="im-step-bar3__item">
                      <div className="im-step-bar3__item__indicator">
                        <span className="fs-70 fw-900 text-yellow2">2</span>
                      </div>
                      <div className="im-step-bar3__item__title">EN İYİ FİYAT</div>
                      <div className="im-step-bar3__item__description">
                        Açık artırmanın mimimum satış fiyatını beraber belirleyelim, gelen teklifler rekabet etsin. Makinanızı en iyi fiyata satalım.
                      </div>
                    </li>
                    <li className="im-step-bar3__item">
                      <div className="im-step-bar3__item__indicator">
                        <span className="fs-70 fw-900 text-yellow2">3</span>
                      </div>
                      <div className="im-step-bar3__item__title">HIZLI VE SORUNSUZ ÖDEME</div>
                      <div className="im-step-bar3__item__description">
                        Makinanızı 30 gün içinde satalım, ödemeyi sorunsuz teslim alalım. Makina satış sürecinizi biz yönetelim.
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-15 col-lg">
                <div className="im-box im-box--white im-box--shadow im-box--height-100p">
                  <div className="text-center mb-2">
                    <h2 className="fs-16 fw-900">Bize Ulaşın</h2>
                  </div>
                  <div className="text-center">
                    <p>
                      Her türlü soru ve bilgi almak için formumuzu doldurun, size hemen ulaşalım.
                    </p>
                  </div>
                  <ContactUsForm />
                </div>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <h2 className="h5">Müşterilerinize Kolayca Ulaşın</h2>
              </div>
              <div className="col-15">
                <p>
                  Türkiye genelinden site ziyaretçilerimize makinanızı sunalım, tek tıkla online teklif versinler. Doğru müşteriden doğru teklifi alıp, en iyi fiyata satalım.
                  30 gün içinde işlemleri halledelim. Tüm satış sürecinizi biz yönetelim.
                </p>
              </div>
            </div>
            <div className="row mb-30 align-items-stretch">
              {
                _.map(items, (item, index) => (
                  <Feature key={index} data={item} />
                ))
              }
            </div>
            <SellYourMachineIn30Days />
            <ContactUs about="Açık Artırma Süreciyle" />
          </div>
        </div>
      </div>

      {/* !!! TODO !!!
                    <section class="bg-gray3-v-half d-flex flex-column align-items-center pt-5">
                        <h2 class="text-white fs-16 fw-900 mb-30 text-center pl-3 pr-3">WE ARE THE MARKETPACE SELLERS CAN TRUST</h2>
                        <div class="w-100">
                            <div class="testimonial-slider2 im-slider" data-slider-id="testimonials2">
                                <div class="testimonial-slider2__item">
                                    <div class="im-box im-box--white im-box--shadow text-center">
                                        <svg class="wh-60 d-inline-block mb-4">
                                            <use xlink:href="./assets/image/icons.svg#ic-quote-gray" />
                                        </svg>
                                        <div class="fw-500 mb-4">
                                            IronPlanet worked diligently to ensure a fair market value sales price. In the end, this sale enabled us to successfully
                                            execute our disposition strategy.
                                        </div>
                                        <div class="fs-14 mb-4">
                                            SWIFT TRANSPORTATION
                                        </div>
                                    </div>
                                </div>
                                <div class="testimonial-slider2__item">
                                    <div class="im-box im-box--white im-box--shadow text-center">
                                        <svg class="wh-60 d-inline-block mb-4">
                                            <use xlink:href="./assets/image/icons.svg#ic-quote-gray" />
                                        </svg>
                                        <div class="fw-500 mb-4">
                                            IronPlanet worked diligently to ensure a fair market value sales price. In the end, this sale enabled us to successfully
                                            execute our disposition strategy.
                                        </div>
                                        <div class="fs-14 mb-4">
                                            SWIFT TRANSPORTATION
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    */}
    </main>
  );
};

SimpleSalesProcess.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Kolay Satış Sistemi',
    },
  };
};

SimpleSalesProcess.Layout = Layout;

export default withTranslation('common')(SimpleSalesProcess);
